export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Non-binary", label: "Non-binary" },
  { value: "Transfeminine", label: "Transfeminine" },
  { value: "Transmasculine", label: "Transmasculine" },
  { value: "Two-spirit", label: "Two-spirit" }
];